module.exports = __webpack_public_path__ + "static/media/home.6b9aba14.svg";